import * as Yup from 'yup'
import {
  CLICK_THROUGH_LINK,
  DESCRIPTION_ENTER,
  DESCRIPTION_OPTION,
  DESCRIPTIONS_LIST,
  HEADLINE_ENTER,
  HEADLINE_OPTION,
  HEADLINES_LIST
} from './fields'
import { getHeadlineShape, urlValidation } from '../../../features/validations/other'
import { FILE_URL } from '../../ReusableFormFields/AdFileUpload/fields'

export const primaryTextMaxLength = 2000
export const headlineMaxLength = 255

export const primaryTextItemShape = Yup.object({
  text: Yup.string()
    .max(primaryTextMaxLength, `Primary text should have maximum ${primaryTextMaxLength} characters`)
    .required('This field should not be empty')
})

export const headlineShape = getHeadlineShape(headlineMaxLength)

export const descriptionShape = Yup.object({
  text: Yup.string().required('This field should not be empty')
})

export const mediaItemShape = {
  // FILE
  [FILE_URL]: Yup.string().required('Please select Image or Video file'),
  // CLICK TROUGH LINK
  [CLICK_THROUGH_LINK]: urlValidation,
  // HEADLINE
  [HEADLINES_LIST]: Yup.array().when(HEADLINE_OPTION, {
    is: HEADLINE_ENTER,
    then: () => Yup.array().of(headlineShape)
  }),
  // DESCRIPTION
  [DESCRIPTIONS_LIST]: Yup.array().when(DESCRIPTION_OPTION, {
    is: DESCRIPTION_ENTER,
    then: () => Yup.array().of(descriptionShape)
  })
}

export const mediaItemSchema = Yup.object(mediaItemShape)
